import * as MetricCard from 'assets/js/pages/engage/workflows/components/MetricCard';
import { getMessageTypesFromSteps } from 'assets/js/pages/engage/workflows/utils/filterMessageActionTypes';
import { useCurrentWorkflowSteps } from 'customHooks/useCurrentWorkflowSteps';

const WorkflowDetailMetricCards = () => {
    const { data: workflowSteps } = useCurrentWorkflowSteps();
    const messageTypes = getMessageTypesFromSteps(workflowSteps);

    if (messageTypes.length === 0) return null;

    return (
        <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
            <MetricCard.Root
                initialOption="total_revenue_from_messages"
                messageTypes={messageTypes}
            >
                <MetricCard.Header>
                    <MetricCard.Icon />
                    <MetricCard.Dropdown />
                </MetricCard.Header>
                <MetricCard.Content />
            </MetricCard.Root>
            <MetricCard.Root initialOption="average_revenue" messageTypes={messageTypes}>
                <MetricCard.Header>
                    <MetricCard.Icon />
                    <MetricCard.Dropdown />
                </MetricCard.Header>
                <MetricCard.Content />
            </MetricCard.Root>
            <MetricCard.Root initialOption="conversion_rate" messageTypes={messageTypes}>
                <MetricCard.Header>
                    <MetricCard.Icon />
                    <MetricCard.Dropdown />
                </MetricCard.Header>
                <MetricCard.Content />
            </MetricCard.Root>
        </div>
    );
};

export { WorkflowDetailMetricCards };
